import { DATA_PRIVACY_REQUEST_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import ObjectDefinitionRecord from '../ObjectDefinitionRecord';
const DataPrivacyRequest = ObjectDefinitionRecord({
  enableAsAssociatedType: true,
  hasAccess: (isUngated, hasScope) => isUngated('PrivacyCenter:DataPrivacyRequest') && hasScope('super-admin'),
  objectTypeId: DATA_PRIVACY_REQUEST_TYPE_ID,
  referenceObjectType: 'DATA_PRIVACY_REQUEST_PROPERTIES'
});
export default DataPrivacyRequest;